import { render, staticRenderFns } from "./FiltroCobranza.vue?vue&type=template&id=e0c97568&scoped=true"
import script from "./FiltroCobranza.vue?vue&type=script&lang=js"
export * from "./FiltroCobranza.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0c97568",
  null
  
)

export default component.exports